// extracted by mini-css-extract-plugin
export default {"loaderOverlay":"Loader_loaderOverlay__n8mWz"};